import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Work", href: "#work" },
  { label: "Ethos", href: "#ethos" },
  { label: "Contact", href: "#contact" },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <header
        className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
          open
            ? "bg-ink border-b border-white/5"
            : scrolled
            ? "bg-ink/85 backdrop-blur-md border-b border-white/5"
            : "bg-transparent border-b border-transparent"
        }`}
      >
        <nav className="mx-auto flex max-w-6xl items-center justify-between px-6 py-5">
          <a
            href="#top"
            onClick={() => setOpen(false)}
            className="font-body text-xs font-medium tracking-luxe uppercase text-ivory"
          >
            Binary&nbsp;Artisan
          </a>
          <ul className="hidden items-center gap-8 sm:flex">
            {links.map(({ label, href }) => (
              <li key={label}>
                <a
                  href={href}
                  className="text-xs font-light tracking-[0.18em] uppercase text-stone transition-colors duration-300 hover:text-gold"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
          <button
            type="button"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            className="-mr-2 p-2 text-ivory transition-colors duration-300 hover:text-gold sm:hidden"
          >
            {open ? (
              <X size={22} strokeWidth={1.25} />
            ) : (
              <Menu size={22} strokeWidth={1.25} />
            )}
          </button>
        </nav>
      </header>
      <div
        className={`fixed inset-0 z-40 flex flex-col bg-ink pt-20 transition-opacity duration-300 sm:hidden ${
          open ? "opacity-100" : "pointer-events-none opacity-0"
        }`}
      >
        <ul className="flex flex-1 flex-col justify-center gap-2 px-8">
          {links.map(({ label, href }, i) => (
            <li key={label} className="border-b border-white/5">
              <a
                href={href}
                onClick={() => setOpen(false)}
                className="group flex items-baseline justify-between py-6"
              >
                <span className="font-display text-3xl font-medium text-ivory transition-colors duration-300 group-hover:text-gold">
                  {label}
                </span>
                <span className="text-xs font-light tracking-[0.2em] text-gold/70">
                  0{i + 1}
                </span>
              </a>
            </li>
          ))}
        </ul>
        <p className="px-8 pb-10 text-[0.65rem] font-light tracking-luxe uppercase text-stone">
          Bespoke Digital Craftsmanship
        </p>
      </div>
    </>
  );
};

export default Nav;
